'use client';

import { useEffect, useRef } from 'react';
import gsap from 'gsap/all';
import { Text, Container, useTranslation } from '@weareconceptstudio/core';

//* Components
import PrivacyPolicyItem from '../components/Item';

//* Helpers
import { animationTitle } from '@/helpers/_animationTitle';

//* Style
import PrivacyPolicyTemplateStyle from './style';

const PrivacyPolicyTemplate = ({ pageData }) => {
	const { translate } = useTranslation();

	//! Refs
	const refSplit = useRef();
	const titleRef = useRef();

	useEffect(() => {
		gsap.to('.wrapper-items', {
			opacity: 1,
			duration: 0.6,
			ease: 'power2.in',
			delay: 0.3,
		});

		animationTitle({ element: titleRef.current, ref: refSplit });
	}, []);

	return (
		<PrivacyPolicyTemplateStyle>
			<Container row>
				<Text
					tag={'h2'}
					ref={titleRef}
					className={'title-privacy col-6 col-t-12 h2 uppercase opacity-zero hidden-container'}>
					{pageData.title}
				</Text>

				<div className='empty col-6 col-t-12' />
			</Container>

			<Container
				row
				isSection>
				<div className='col-6' />

				<div className='wrapper-items col-6 col-t-12 opacity-zero'>
					{pageData.info.map((item, i) => {
						return (
							<PrivacyPolicyItem
								key={i}
								{...item}
							/>
						);
					})}
					<div className='last-update'>
						<Text className={'p4 font-montserrat-arm-medium'}>
							{translate('lastUpdate')} {pageData.updatedDate}
						</Text>
					</div>
				</div>
			</Container>
		</PrivacyPolicyTemplateStyle>
	);
};

export default PrivacyPolicyTemplate;
